export const canHandleApplePay = () => {
  return window.ApplePaySession && window.ApplePaySession.canMakePayments();
};
